/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from "react";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {usePartnerData} from "../../../../../providers/partnerData";
import {IPresencial, ITeleconsulta} from "../../types";
import AppointmentCancellation from "../../../../Modals/AppointmentCancellation";

export const Teleconsulta = ({
  paymentStatus,
  isPastAppointment,
  appointment,
}: ITeleconsulta) => {
  const navigate = useNavigate();
  const {partnerUrl} = usePartnerData();

  const [modal, setModal] = useState(false);

  let paymentStatusMessage = "";
  let icon = "";
  switch (paymentStatus) {
    case 1:
      paymentStatusMessage = "Pagamento confirmado";
      icon = "la-video text-success";
      break;
    case 2:
      paymentStatusMessage = "Pagamento cancelado, refaça o agendamento";
      icon = "la-file-invoice-dollar text-danger";
      break;
    case 3:
      paymentStatusMessage = "Aguardando pagamento";
      icon = "la-video text-muted";
      break;
    case 4:
      paymentStatusMessage = "Pagamento reembolsado";
      icon = "la-video text-danger";
      break;
  }

  return (
    <>
      <div className="col-12 col-md-5 col-lg-3">
        <div className="row align-items-center justify-content-center pt-3 pt-md-0">
          <div className="col-4 col-lg-3 text-end pe-0">
            <i className={`fs-3 fw-bolder las la-fw ${icon}`}></i>
          </div>
          <div className="col-8 col-lg-9 pl-0 text-left text-md-left">
            <p className="fw-medium mb-0">Teleconsulta</p>
            <p className="small lh-1 mb-0">
              <small>{paymentStatusMessage}</small>
            </p>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-4 pt-3 pt-lg-0 text-center border-top mt-3 border-lg-top-0 mt-lg-0 d-flex flex-wrap gap-2 justify-content-center">
        {paymentStatus === 1 && !isPastAppointment && (
          <>
            {" "}
            {/* Mostrando botão aguardar atendimento 10 min antes da consulta */}
            {moment().isBetween(
              moment(
                moment(appointment.date)
                  .add(appointment.scheduleTime.initialTimeHours, "h")
                  .add(appointment.scheduleTime.initialTimeMinutes, "m")
                  .subtract(10, "m")
              ),
              moment(appointment.date).add(1, "d")
            ) ? (
              <button
                className="text-nowrap btn btn-sm btn-success"
                onClick={() =>
                  navigate(`/${partnerUrl}/info`, {state: {appointment}})
                }
              >
                <i className="las la-video me-2"></i>AGUARDAR ATENDIMENTO
              </button>
            ) : (
              <button
                className="text-nowrap btn btn-sm btn-primary"
                onClick={() =>
                  navigate(`/${partnerUrl}/atendimento-detalhes`, {
                    state: {appointment},
                  })
                }
              >
                <i className="las la-eye me-2"></i>VISUALIZAR
              </button>
            )}
            <button
              className="text-nowrap btn btn-sm btn-outline-danger"
              onClick={() => setModal(true)}
            >
              <i className="las la-times me-2"></i>CANCELAR
            </button>
          </>
        )}

        {(paymentStatus === 2 || paymentStatus === 4) && (
          <button
            className="text-nowrap btn btn-sm btn-success"
            onClick={() =>
              navigate(`/${partnerUrl}/profissional`, {
                state: appointment.specialistDoctor.id,
              })
            }
          >
            <i className="las la-redo-alt me-2"></i>
            REAGENDAR
          </button>
        )}

        {paymentStatus === 3 && !isPastAppointment && (
          <>
            {/* TODO: direcionar para tela com QR code Pix ou com arquivo do Boleto */}
            <button className="text-nowrap btn btn-sm btn-success">
              <i className="las la-dollar-sign me-2"></i>PAGAR
            </button>
            <button
              className="text-nowrap btn btn-sm btn-outline-danger"
              onClick={() => setModal(true)}
            >
              <i className="las la-times me-2"></i>CANCELAR
            </button>
          </>
        )}

        {(paymentStatus === 1 || paymentStatus === 3) &&
          !!isPastAppointment && (
            <button
              className="text-nowrap btn btn-sm btn-primary"
              onClick={() =>
                navigate(`/${partnerUrl}/atendimento-detalhes`, {
                  state: {appointment},
                })
              }
            >
              <i className="las la-eye me-2"></i>VISUALIZAR
            </button>
          )}
      </div>

      {/* Modal de cancelamento de consulta */}
      <AppointmentCancellation
        modal={modal}
        setModal={setModal}
        appointment={appointment}
      />
    </>
  );
};

export const Presencial = ({
  address,
  isPastAppointment,
  appointment,
}: IPresencial) => {
  const {partnerUrl} = usePartnerData();

  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="col-12 col-md-5 col-lg-3">
        <div className="row align-items-center justify-content-center pt-3 pt-md-0">
          <div className="col-4 col-lg-3 text-end pe-0">
            <i className="fs-3 fw-bolder las la-fw la-map-marker text-success"></i>
          </div>
          <div className="col-8 col-lg-9 pl-0 text-left text-md-left">
            <p className="fw-medium mb-0">{address.name}</p>
            <p className="small lh-1 mb-0">
              <small>{`${address.addressName}, ${address.number} ${address.optionalName} ${address.neighborhood} - ${address.city}/${address.state}`}</small>
            </p>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-4 pt-3 pt-lg-0 text-center border-top mt-3 border-lg-top-0 mt-lg-0 d-flex flex-wrap gap-2 justify-content-center">
        <button
          className="text-nowrap btn btn-sm btn-primary"
          onClick={() =>
            navigate(`/${partnerUrl}/atendimento-detalhes`, {
              state: {appointment},
            })
          }
        >
          <i className="las la-eye me-2"></i>VISUALIZAR
        </button>
        {!isPastAppointment && (
          <button
            className="text-nowrap btn btn-sm btn-outline-danger"
            onClick={() => setModal(true)}
          >
            <i className="las la-times me-2"></i>CANCELAR
          </button>
        )}
      </div>

      {/* Modal de cancelamento de consulta */}
      <AppointmentCancellation
        modal={modal}
        setModal={setModal}
        appointment={appointment}
      />
    </>
  );
};
